import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { uploadImgBlob } from '@/api';
import type { ImageField, LevelItem } from './types';
import { normalizeUploadAssetUrl } from './asset-url';

export const useLevelExplorerEditMedia = (options: {
  editForm: Partial<LevelItem>;
  requireLogin: () => boolean;
}) => {
  const { editForm, requireLogin } = options;
  const uploadingField = ref<'' | ImageField>('');
  const backgroundPreviewUrl = ref('');
  const coverPreviewUrl = ref('');

  const revokePreviewUrls = () => {
    if (backgroundPreviewUrl.value) URL.revokeObjectURL(backgroundPreviewUrl.value);
    if (coverPreviewUrl.value) URL.revokeObjectURL(coverPreviewUrl.value);
    backgroundPreviewUrl.value = '';
    coverPreviewUrl.value = '';
  };

  const handleImageFile = (field: ImageField, file: File) => {
    if (!requireLogin()) return;
    if (!file.type.startsWith('image/')) {
      ElMessage.warning('请选择图片文件');
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      ElMessage.warning('图片不能超过 8MB');
      return;
    }

    const localUrl = URL.createObjectURL(file);
    if (field === 'backgroundImg') {
      if (backgroundPreviewUrl.value) URL.revokeObjectURL(backgroundPreviewUrl.value);
      backgroundPreviewUrl.value = localUrl;
    } else {
      if (coverPreviewUrl.value) URL.revokeObjectURL(coverPreviewUrl.value);
      coverPreviewUrl.value = localUrl;
    }

    uploadingField.value = field;
    uploadImgBlob({
      url: 'file/uploadImg',
      file,
      data: { fileName: file.name },
      loading: { open: false, text: '' },
      success: (res: any) => {
        uploadingField.value = '';
        if (res.code !== 0) {
          ElMessage.error(res.msg || '图片上传失败');
          return;
        }
        const uploadedUrl = normalizeUploadAssetUrl(res.data?.url || '');
        if (!uploadedUrl) {
          ElMessage.warning('图片已选择，但未获取到上传地址');
          return;
        }
        editForm[field] = uploadedUrl;
        ElMessage.success(field === 'backgroundImg' ? '背景图已上传' : '封面图已上传');
      },
      error: () => {
        uploadingField.value = '';
        ElMessage.error('图片上传失败，请稍后重试');
      }
    });
  };

  return {
    uploadingField,
    backgroundPreviewUrl,
    coverPreviewUrl,
    revokePreviewUrls,
    handleImageFile
  };
};
